// Las rutas cambian de palabra según el idioma (/de/buecher ↔ /es/libros).
// Esta es la única tabla que lo sabe, para que el menú, el pie y el
// selector de idioma no se contradigan nunca.

export const SEGMENTS = {
  books: { de: "buecher", es: "libros" },
  services: { de: "werkstatt", es: "taller" },
};

const PAIRS = Object.values(SEGMENTS).filter((s) => s.de !== s.es);

/** Devuelve la misma página en el otro idioma. */
export function swapLangPath(pathname, from, to) {
  let p = pathname.startsWith(`/${from}`)
    ? pathname.replace(`/${from}`, `/${to}`)
    : `/${to}`;
  for (const seg of PAIRS) {
    p = p.replace(new RegExp(`(^|/)${seg[from]}(/|$)`), `$1${seg[to]}$2`);
  }
  return p;
}

export const booksPath = (lang) => `/${lang}/${SEGMENTS.books[lang]}`;
export const bookPath = (lang, slug) => `${booksPath(lang)}/${slug}`;
export const servicesPath = (lang) => `/${lang}/${SEGMENTS.services[lang]}`;
export const servicePath = (lang, id) => `${servicesPath(lang)}/${id}`;
